<template>
    <div class="pendingApprovalWrap">
        <QueryHeader @queryData="handleQueryData"></QueryHeader>
        <div class="exportWrap">
            <el-button
                type="primary"
                icon="el-icon-s-check"
                @click="handleApproval()"
            >批量审批
            </el-button>
            <el-button
                type="primary"
                icon="el-icon-download"
                @click="exportClick()"
            >导出
            </el-button>
        </div>
        <TableContent
            :tableData="tableData"
            :isTableMultiple="true"
            :selectList.sync="selectList"
            left-action-btn="审批"
            right-action-btn="详情"
            @actionBtnClick="tableActionClick"
        ></TableContent>
        <PageFooter
            :totalCount="totalCount"
            :pageIndex="pageIndex"
            :pageSize="pageSize"
            @pageChange="handlePageChange"
        ></PageFooter>
        <ApproveDialog :visible="approveDialog" @handleChange="handleChangeApprove"></ApproveDialog>
    </div>
</template>

<script>
import QueryHeader from "../components/query";
import TableContent from "../components/table";
import PageFooter from "../components/page";
import ApproveDialog from "./approveDialog"
import {
    getWorkBenchAuditListApi,
    exportWorkBenchAuditListApi,
    batchSubmitApproveProcessApi
} from "../../../services/workbenchServices";
import {exportExcelService2} from "../../../services/allContractServices";
import {getRouteIdByType} from "../../approveComponents/approve";

export default {
    name: "pendingApproval",
    components: {QueryHeader, TableContent, PageFooter, ApproveDialog},
    data() {
        return {
            queryParams: {}, //查询条件
            pageIndex: 1,
            pageSize: 10,
            totalCount: 0,
            tableData: [],
            selectList: [],
            approveDialog: false
        };
    },
    created() {
        this.queryData();
        this.bus.$on("headerActiveTabName", (item) => {
            if (item === "待审批列表") {
                this.queryData();
            }
        });
    },
    methods: {
        handleQueryData(params) {
            this.queryParams = params;
            this.pageIndex = 1;
            this.queryData();
        },
        handlePageChange(data) {
            this[data.type] = data.value;
            this.queryData();
        },
        queryData() {
            const params = {
                ...this.queryParams,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
            };
            this.emptySelectList()
            getWorkBenchAuditListApi(params)
                .then((res) => {
                    if (res.code == 10000000) {
                        this.tableData = res.data || [];
                        this.totalCount = res.total || 0;
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch(() => {
                    this.$message.error("网络请求失败");
                });
        },

        tableActionClick(data) {
            const {btnName, row} = data;
            this.bus.$emit("navMenuChange", {
                routeId: getRouteIdByType(row.type),
                routeParam: {
                    //approveFlag currentApprove  审批项目  waitApproveDetail    待审批列表进审批详情    historyApproveDetail 审批历史列表进审批详情
                    approveFlag: btnName === "审批" ? 'currentApprove' : 'waitApproveDetail',
                    id: row.itemId,
                    approveType: row.type
                },
            });
        },
        exportClick() {
            exportWorkBenchAuditListApi(this.queryParams)
                .then((res) => {
                    if (res.code == 10000000) {
                        exportExcelService2(res.data).then((res1) => {
                            this.$alert("导出成功", "提示", {
                                confirmButtonText: "确定",
                            });
                        });
                    } else if (res.code >= 10000000) {
                        this.$alert(res.msg, "提示", {
                            confirmButtonText: "确定",
                        });
                    } else {
                        this.$alert("系统异常", "提示", {
                            confirmButtonText: "确定",
                        });
                    }
                })
                .catch(() => {
                    this.$message.error("网络请求失败");
                });
        },
        handleChangeApprove(type, value) {
            this.approveDialog = false
            if (type) {
                const params = {
                    itemList: this.selectList.map(i => {
                        let item={}
                        item.itemId=i.itemId;
                        item.type=i.type
                        return item
                    }),
                    ...value,
                    type: this.selectList[0]['type']
                }
                batchSubmitApproveProcessApi(params).then((res) => {
                    if (res.code == 10000000) {
                        this.$alert(res.msg, "提示", {
                            confirmButtonText: "确定",
                        });
                        this.queryData()
                        this.emptySelectList()
                    } else if (res.code >= 10000000) {
                        this.$alert(res.msg, "提示", {
                            confirmButtonText: "确定",
                        });
                    } else {
                        this.$alert("系统异常", "提示", {
                            confirmButtonText: "确定",
                        });
                    }
                })
                    .catch(() => {
                        this.$message.error("网络请求失败");
                    });

            }
        },
        handleApproval() {
            if (this.selectList.length < 1) {
                this.$message("请至少选择一条数据")
                return
            }
            // console.log(this.selectList)
            // const type = this.selectList[0].type
            // const isSameType = this.selectList.every(i => i.type === type)
            // if (!isSameType) {
            //     this.$message("请选择同种类型的数据")
            //     return
            // }
            this.approveDialog = true
        },
        emptySelectList() {
            this.selectList = []
        }
    },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.pendingApprovalWrap {
    height: 100%;
    background-color: white;
    padding: 16px;

    .exportWrap {
        text-align: right;
        margin: 16px 0;
    }
}
</style>
